export enum SelfAssessmentStep {
  INTRO = 'INTRO',
  QUESTION = 'QUESTION',
  RESULT = 'RESULT',
}
